import * as React from 'react'
import Img from 'components/common/Img'
import SanityBlock from 'components/common/SanityBlock'
import CTALink from 'components/common/CTALink'

const HeroLanding = ({ title, _rawDescription, link, image }) => {
  return (
    <section className="relative pt-12">
      <Img
        className="!absolute inset-0 w-full h-full object-cover"
        {...image}
      />

      <div className="relative max-w-screen-xl mx-auto py-12 md:py-16 px-4 text-white">
        <div className="max-w-[640px] richtext">
          <h1 className="h0">{title}</h1>
          <SanityBlock body={_rawDescription} />
          {!!link && <CTALink {...link} />}
        </div>
      </div>
    </section>
  )
}

export default HeroLanding
